export default __webpack_public_path__ + "static/media/roboto-latin-900.870c8c14.woff2";